import { SortType } from "./index.js";
import { isAscValue, isCommaToken, isDescValue, isLeftParentToken, isRightParentToken, isSemicolonToken, isStringToken } from "../helper.js";
//#region ../schema-sql-parser/dist/parser/statement/index.columns.js
function indexColumnsParser(tokens, $pos) {
	const isString = isStringToken(tokens);
	const isLeftParent = isLeftParentToken(tokens);
	const isRightParent = isRightParentToken(tokens);
	const isComma = isCommaToken(tokens);
	const isSemicolon = isSemicolonToken(tokens);
	const isDesc = isDescValue(tokens);
	const isAsc = isAscValue(tokens);
	const isToken = () => $pos.value < tokens.length && !isSemicolon($pos.value);
	const isPrefixLength = (pos) => isString(pos + 1) && /^\d+$/.test(tokens[pos + 1].value) && isRightParent(pos + 2);
	const indexColumns = [];
	let indexColumn = {
		name: "",
		sort: SortType.asc
	};
	let expression = false;
	$pos.value++;
	while (isToken() && !isRightParent($pos.value)) {
		if (isLeftParent($pos.value)) {
			expression ||= !indexColumn.name || !isPrefixLength($pos.value);
			let depth = 0;
			while (isToken()) {
				if (isLeftParent($pos.value)) depth++;
				else if (isRightParent($pos.value) && --depth === 0) break;
				$pos.value++;
			}
			if (!isToken()) break;
		}
		if (!indexColumn.name && isString($pos.value) && !isDesc($pos.value) && !isAsc($pos.value)) indexColumn.name = tokens[$pos.value].value;
		if (isDesc($pos.value)) indexColumn.sort = SortType.desc;
		if (isComma($pos.value)) {
			indexColumns.push(indexColumn);
			indexColumn = {
				name: "",
				sort: SortType.asc
			};
		}
		$pos.value++;
	}
	if (isSemicolon($pos.value)) return [];
	if (indexColumn.name !== "") indexColumns.push(indexColumn);
	$pos.value++;
	return expression ? [] : indexColumns;
}
//#endregion
export { indexColumnsParser };
